module.exports = __webpack_public_path__ + "static/media/spil-id-background.c377ac84.png";